module.exports = __webpack_public_path__ + "img/vue.41f1aa2a.png";